import { Box, Text } from "@chakra-ui/react";
import { ViewProps } from "../certification-broadcast-settings.types";
import NewSettingRow from "./NewSettingRow";
import SettingRow from "./SettingRow";

export default function SettingsTable(props: ViewProps) {
  return (
    <Box>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>ID</th>
              <th>Office Name</th>
              <th>Certification</th>
              <th>Permitted Certifications</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <NewSettingRow {...props} />
            {props.settings.map((setting) => (
              <SettingRow key={String(setting.id)} setting={setting} {...props} />
            ))}
            {props.settings.length === 0 && (
              <tr>
                <td colSpan={5}>
                  <Text color="gray.500" mb={0}>
                    No certification broadcast settings yet.
                  </Text>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Box>
  );
}
